/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/_utils.js":
/*!**************************!*\
  !*** ./src/js/_utils.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   closeMegamenu: () => (/* binding */ closeMegamenu),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   openMegamenu: () => (/* binding */ openMegamenu),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
function closeMegamenu(megamenu, currentLink) {
  megamenu.classList.remove('active');
  megamenu.setAttribute('aria-expanded', 'false');
  if (window.innerWidth >= 1280) {
    const header = document.querySelector('.main-header');
    header.classList.remove('is-dark');
  }
  if (currentLink) {
    currentLink.classList.remove('active');
  }
  document.body.style.overflow = null;
}
function openMegamenu(megamenu, currentLink) {
  megamenu.classList.add('active');
  megamenu.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
  if (window.innerWidth >= 1280) {
    const header = document.querySelector('.main-header');
    header.classList.add('is-dark');
  }
  if (currentLink) {
    currentLink.classList.add('active');
  }
  var closeBtns = megamenu.querySelectorAll('.megamenu-close-action');
  closeBtns.forEach(closeBtn => {
    closeBtn.addEventListener("click", function close() {
      closeMegamenu(megamenu, currentLink);
      this.removeEventListener('click', close);
    });
  });
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
/*!*************************************!*\
  !*** ./src/js/templates/product.js ***!
  \*************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_utils */ "./src/js/_utils.js");


/*
 * Events:
 * variant-changed: triggered when the variant select input is changed.
 * media-changed: triggered when the user clicked to change the main image. (Used for the thumbnail carousel)
 * quantity-changed: triggered when the product quantity is changed.
 */

customElements.define('product-notification', class ProductNotification extends HTMLElement {
  constructor() {
    super();
    this.$notification = this;
    this.$icon = this.querySelector('.icon');
    this.$message = this.querySelector('.message');
  }
  setType(type) {
    this.$notification.classList.remove('border-[color:var(--error-color)]', 'text-[color:var(--error-color)]', 'border-[color:var(--success-color)]', 'text-[color:var(--success-color)]');
    if (type === 'error') {
      this.$notification.classList.add('border-[color:var(--error-color)]', 'text-[color:var(--error-color)]');
    } else if (type === 'success') {
      this.$notification.classList.add('border-[color:var(--success-color)]', 'text-[color:var(--success-color)]');
    }
    this.$icon.childNodes.forEach(function (child) {
      if (child.classList) {
        child.classList.add('hidden');
        if (child.classList.contains(type)) {
          child.classList.remove('hidden');
        }
      }
    });
  }
  setMessage(message) {
    this.$message.innerHTML = message;
    if (message.includes('__cart-url__')) {
      this.$message.innerHTML = this.$message.innerHTML.replace('__cart-url__', '');
      const cartLink = document.createElement('a');
      cartLink.href = Axial.routes.cart_url;
      cartLink.classList.add('underline');
      const strings = Axial.productPage.getStrings();
      cartLink.innerHTML = strings.add_to_cart_form.view_cart;
      this.$message.appendChild(cartLink);
    }
  }
  show() {
    this.$notification.classList.remove('hidden');
    this.$notification.classList.add('block');
  }
  hide() {
    this.$notification.classList.remove('block');
    this.$notification.classList.add('hidden');
  }
});
function productPageInit() {
  // Update the page url on page load.
  Axial.productPage.updateProductPageUrl();
  Axial.productPage.updateVariantOptionStatus();

  // Listener for the variant-changed trigger.
  document.addEventListener('variant-changed', e => {
    const variantId = e.detail.variant;

    // Set variant data
    Axial.productPage.selectVariant(variantId);
  });

  // Listener for the media-changed trigger.
  document.addEventListener('media-changed', e => {
    const media = e.detail.thumbnail;

    // Select variant if needed
    var variant = Axial.productPage.getVariantFromMediaId(media.mediaId);
    if (variant) {
      Axial.productPage.selectVariant(variant.id);
    } else {
      Axial.productPage.selectProductMedia(media.mediaId);
    }
  });
  var $thumbnails = document.querySelectorAll('.product_thumbnail_nav');
  $thumbnails.forEach(function (thumbnail) {
    var dataset = thumbnail.dataset;
    thumbnail.addEventListener('click', e => {
      Axial.productPage.selectProductMedia(dataset.mediaId);
    });
  });
  var $previousImage = document.querySelector('.media-previous-action');
  if ($previousImage) {
    $previousImage.addEventListener('click', e => {
      var $currentMedia = document.querySelector('.product_thumbnail_nav.active');
      var $currentMediaPosition = $currentMedia.dataset.mediaLoopPosition;
      var $previousMedia = document.querySelector('.product_thumbnail_nav[data-media-loop-position="' + (parseInt($currentMediaPosition) - 1) + '"]');
      if (!$previousMedia) {
        $previousMedia = document.querySelector('.product_thumbnail_nav:last-child');
      }
      if (!$previousMedia) {
        return false;
      }
      Axial.productPage.selectProductMedia($previousMedia.dataset.mediaId);
    });
  }
  var $nextImage = document.querySelector('.media-next-action');
  if ($nextImage) {
    $nextImage.addEventListener('click', e => {
      var $currentMedia = document.querySelector('.product_thumbnail_nav.active');
      var $currentMediaPosition = $currentMedia.dataset.mediaLoopPosition;
      var $nextMedia = document.querySelector('.product_thumbnail_nav[data-media-loop-position="' + (parseInt($currentMediaPosition) + 1) + '"]');
      if (!$nextMedia) {
        $nextMedia = document.querySelector('.product_thumbnail_nav[data-media-loop-position="0"]');
      }
      if (!$nextMedia) {
        return false;
      }
      Axial.productPage.selectProductMedia($nextMedia.dataset.mediaId);
    });
  }
  var $optionSelect = document.querySelectorAll('.variant-option select');
  $optionSelect.forEach(function (select) {
    select.addEventListener('change', e => {
      const newOptionId = e.target.name;
      const newValue = e.target.value;
      const optionArray = ['option1', 'option2', 'option3'];
      var options = {};
      optionArray.forEach(function (optionId) {
        let $currentActiveButton = document.querySelector('.variant-option-button[data-option-id="' + optionId + '"].active');
        if (!$currentActiveButton) {
          $currentActiveButton = document.querySelector('.variant-option select[name="' + optionId + '"]');
        }
        if (optionId === newOptionId) {
          options[optionId] = newValue;
        } else if ($currentActiveButton) {
          options[optionId] = $currentActiveButton.dataset.value ? $currentActiveButton.dataset.value : $currentActiveButton.value;
        } else {
          options[optionId] = false;
        }
      });
      let variant = Axial.productPage.getVariantFromSpecificOptions(options);
      if (variant) {
        Axial.productPage.selectVariant(variant.id);
      } else {
        variant = Axial.productPage.getFirstVariantFromOptions(newOptionId, newValue);
        if (variant) {
          Axial.productPage.selectVariant(variant.id);
        }
      }
    });
  });
  var $optionButtons = document.querySelectorAll('.variant-option-button');
  $optionButtons.forEach(function (button) {
    button.addEventListener('click', e => {
      const $currentButton = e.target;
      const buttonData = e.target.dataset;
      const newOptionId = e.target.dataset.optionId;
      const newValue = e.target.dataset.value;
      const optionArray = ['option1', 'option2', 'option3'];
      var options = {};
      optionArray.forEach(function (optionId) {
        let $currentActiveButton = document.querySelector('.variant-option-button[data-option-id="' + optionId + '"].active');
        if (!$currentActiveButton) {
          $currentActiveButton = document.querySelector('.variant-option select[name="' + optionId + '"]');
        }
        if (optionId === newOptionId) {
          options[optionId] = newValue;
        } else if ($currentActiveButton) {
          options[optionId] = $currentActiveButton.dataset.value ? $currentActiveButton.dataset.value : $currentActiveButton.value;
        } else {
          options[optionId] = false;
        }
      });
      let variant = Axial.productPage.getVariantFromSpecificOptions(options);
      if (variant) {
        Axial.productPage.selectVariant(variant.id);
      } else {
        variant = Axial.productPage.getFirstVariantFromOptions(newOptionId, newValue);
        if (variant) {
          Axial.productPage.selectVariant(variant.id);
        }
      }
    });
  });
}
customElements.define('product-add-to-cart', class ProductAddToCart extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.groupedStatus = this.dataset.grouped;
    if (!this.groupedStatus) {
      const $variantSelectorInput = this.querySelector('#productSelect');
      $variantSelectorInput.addEventListener('change', () => {
        const variantId = $variantSelectorInput.value;
        Axial.productPage.selectVariant(variantId);
      });
      this.form.querySelector('[name=id]').disabled = false;
    }
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.productNotification = document.querySelector('product-notification');
    this.sliderCart = document.querySelector('slider-cart');
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;
    this.productNotification.hide();
    if (this.sliderCart) {
      this.sliderCart.close();
    }
    submitButton.setAttribute('aria-disabled', true);
    this.querySelector('.svg-spinner').classList.remove('hidden');
    this.querySelector('.add-to-cart-text').classList.add('hidden');
    const config = fetchConfig('javascript');
    const formData = new FormData(this.form);
    var data = [];
    if (this.groupedStatus) {
      formData.forEach(function (quantity, variantID) {
        if (parseInt(quantity) > 0) {
          data.push({
            'quantity': quantity,
            'id': variantID
          });
        }
      });
    } else {
      formData.forEach(function (value, name) {
        if (name === 'id' && parseInt(formData.get('quantity')) > 0) {
          data.push({
            'quantity': formData.get('quantity'),
            'id': value
          });
        } else if (name !== 'quantity') {
          if (parseInt(value) > 0) {
            data.push({
              'quantity': value,
              'id': name
            });
          }
        }
      });
    }
    config.body = JSON.stringify({
      'items': data
    });
    fetch(`${Axial.routes.cart_add_url}`, config).then(response => response.json()).then(response => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      if (this.sliderCart) {
        this.sliderCart.open();
      } else {
        const strings = Axial.productPage.getStrings();
        this.productNotification.setType('success');
        this.productNotification.setMessage(strings.add_to_cart_form.added_to_cart);
        this.productNotification.show();
      }

      // Update mini cart
      this.updateMiniCart();
    }).catch(e => {
      console.error(e);
    }).finally(() => {
      submitButton.removeAttribute('aria-disabled');
      this.querySelector('.svg-spinner').classList.add('hidden');
      this.querySelector('.add-to-cart-text').classList.remove('hidden');
    });
  }
  updateMiniCart() {
    fetch(`${Axial.routes.cart_url}.js`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json()).then(response => {
      if (response.status) {
        return;
      }
      Axial.productPage.updateMiniCartCount(response.item_count);
    });
    return this.querySelector('.cart-count');
  }
  handleErrorMessage(errorMessage = false) {
    this.productNotification.setType('error');
    this.productNotification.setMessage(errorMessage);
    this.productNotification.show();
  }
});
customElements.define('product-quantity-selector', class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    // Listener for the variant-changed trigger.
    document.addEventListener('quantity-changed', e => {
      const quantity = e.detail.quantity;

      // Set quantity
      Axial.productPage.updateQuantity(quantity);
    });
    const $quantityInput = this.querySelector('#Quantity');
    $quantityInput.addEventListener('change', () => {
      this.dispatchEvent(new CustomEvent('quantity-changed', {
        bubbles: true,
        composed: true,
        detail: {
          quantity: parseInt($quantityInput.value)
        }
      }));
    });
    const $plusButton = this.querySelector('.quantity-control-plus');
    $plusButton.addEventListener('click', () => {
      const quantity = parseInt($quantityInput.value) + 1;
      Axial.productPage.updateQuantity(quantity);
    });
    const $minusButton = this.querySelector('.quantity-control-minus');
    $minusButton.addEventListener('click', () => {
      const quantity = parseInt($quantityInput.value) - 1;
      Axial.productPage.updateQuantity(quantity);
    });
  }
});
Axial.productPage = {};
Axial.productPage.selectProductMedia = function (mediaId) {
  // Update product image
  var media = Axial.productPage.getProductImage(mediaId);
  if (!media) {
    return false;
  }

  // Update Main Image
  var mainImage = document.querySelector('#ProductPhotoImg');
  var mainVideo = document.querySelector('#ProductVideo');
  if (!mainImage && !mainVideo) {
    return false;
  }
  var externalIframeContainer = document.querySelector('#ProductIframe');
  Axial.productPage.resetGallery(media.media_type);
  if (media.media_type === 'image') {
    const mobileImage = mainImage.querySelector('source');
    const desktopImage = mainImage.querySelector('img');
    mobileImage.srcset = media.src_mobile;
    desktopImage.src = media.src;
  } else if (media.media_type === 'video') {
    const newSource = document.createElement('source');
    newSource.src = media.source;
    newSource.type = media.source_type;
    mainVideo.poster = media.src;
    mainVideo.appendChild(newSource);
  } else if (media.media_type === 'external_video') {
    externalIframeContainer.innerHTML = `<iframe class="h-full w-full" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" src="https://www.youtube.com/embed/${media.external_id}?controls=1&amp;enablejsapi=1&amp;modestbranding=1&amp;playsinline=1&amp;rel=0"></iframe>`;
  }

  // Update select thumbnail
  var $thumbnail = document.querySelector('.product_thumbnail_nav[data-media-id*="' + media.id + '"]');
  if ($thumbnail) {
    document.querySelectorAll('.product_thumbnail_nav').forEach(function (thumbnail) {
      thumbnail.classList.remove('active');
    });
    $thumbnail.classList.add('active');
  }
};
Axial.productPage.resetGallery = function (switchTo) {
  var mainImage = document.querySelector('#ProductPhotoImg');
  var mainVideo = document.querySelector('#ProductVideo');
  var externalIframeContainer = document.querySelector('#ProductIframe');
  if (mainImage) {
    mainImage.classList.add('hidden');
    if (switchTo === 'image') {
      mainImage.classList.remove('hidden');
    }
  }
  if (mainVideo) {
    mainVideo.classList.add('hidden');
    mainVideo.innerHTML = '';
    if (switchTo === 'video') {
      mainVideo.classList.remove('hidden');
    }
  }
  if (externalIframeContainer) {
    externalIframeContainer.classList.add('hidden');
    externalIframeContainer.innerHTML = '';
    if (switchTo === 'external_video') {
      externalIframeContainer.classList.remove('hidden');
    }
  }
};
Axial.productPage.updateProductPageSku = function () {
  const currentVariant = Axial.productPage.getCurrentVariant();
  const $skuContainer = document.querySelector('.product_sku_container');
  const $skuValue = document.querySelector('.product_sku_value');
  if (!$skuContainer && !$skuValue) {
    return false;
  }
  if (currentVariant && currentVariant.sku !== '') {
    $skuValue.innerHTML = currentVariant.sku;
    $skuContainer.classList.remove('hidden');
  } else {
    $skuContainer.classList.add('hidden');
  }
};
Axial.productPage.updateProductPagePrice = function () {
  const currentVariant = Axial.productPage.getCurrentVariant();
  const $price = document.querySelector('.product_price_container .price.regular-price');
  if (!$price) {
    return false;
  }
  let price = 0;
  if ($price.classList.contains('no-trailing')) {
    price = Axial.formatMoney(currentVariant.price, false, false, true);
  } else {
    price = Axial.formatMoney(currentVariant.price, false, false, false);
  }
  if ($price) {
    $price.innerHTML = price;
  }
  const $compareAt = document.querySelector('.product_price_container .price.compare-at');
  if (currentVariant.compare_at_price > 0) {
    let compareAt = 0;
    if ($compareAt && $compareAt.classList.contains('no-trailing')) {
      compareAt = Axial.formatMoney(currentVariant.compare_at_price, false, false, true);
    } else {
      compareAt = Axial.formatMoney(currentVariant.compare_at_price, false, false, false);
    }
    if ($compareAt) {
      $compareAt.innerHTML = compareAt;
      $compareAt.classList.remove('hidden');
    } else {
      const $priceWrapper = $price.parentNode;
      let $compareAtContainer = document.createElement('dov');
      $compareAtContainer.classList.add('price', 'compare-at', 'text-red-500', 'line-through', 'ml-2');
      $compareAtContainer.innerHTML = compareAt;
      $priceWrapper.appendChild($compareAtContainer);
    }
  } else {
    if ($compareAt) {
      $compareAt.classList.add('hidden');
    }
  }
};
Axial.productPage.updateProductPageMedia = function () {
  const currentVariant = Axial.productPage.getCurrentVariant();
  if (currentVariant && currentVariant.featured_media) {
    Axial.productPage.selectProductMedia(currentVariant.featured_media.id);
  } else {
    const currentProduct = Axial.productPage.getCurrentProduct();
    if (currentProduct.media && currentProduct.media[0]) {
      Axial.productPage.selectProductMedia(currentProduct.media[0].id);
    }
  }
};
Axial.productPage.updateAddToCartButton = function () {
  const $addToCartForm = document.querySelector('product-add-to-cart');
  const $addToCartButton = document.querySelector('#AddToCart');
  const $textContainer = $addToCartButton.querySelector('span');
  if (!$addToCartForm || !$addToCartButton || !$textContainer) {
    return false;
  }
  const currentVariant = Axial.productPage.getCurrentVariant();
  const strings = Axial.productPage.getStrings();
  if (!currentVariant.available) {
    $textContainer.innerHTML = strings.add_to_cart_form.button_text_unavailable;
    $addToCartButton.disabled = true;
    $addToCartButton.classList.remove('btn-filled');
    $addToCartButton.classList.add('btn-outlined');
    return false;
  }
  $addToCartButton.classList.add('btn-filled');
  $addToCartButton.classList.remove('btn-outlined');
  $textContainer.innerHTML = strings.add_to_cart_form.button_text;
  $addToCartButton.disabled = false;
};
Axial.productPage.updateUsingAjax = function () {
  const $productInfo = document.getElementById('product-information');
  const $productContent = document.getElementById('product-content');
  let sections = [{
    'section_id': $productInfo.dataset.sectionId,
    'content_to_update': ['coming-soon-section', 'specs-year-section']
  }];
  if ($productContent) {
    sections.push({
      'section_id': $productContent.dataset.sectionId,
      'content_to_update': ['product-content-description', 'product-content-overview', 'product-content-info']
    });
  }
  sections.forEach(function (section) {
    Axial.productPage._ajaxCall(section.section_id, section.content_to_update);
  });
};
Axial.productPage._ajaxCall = function (sectionId, contentToUpdate) {
  const currentVariant = Axial.productPage.getCurrentVariant();
  var $form = document.getElementById('AddToCartForm');
  const formData = new FormData($form);
  const searchParams = new URLSearchParams(formData).toString();
  const url = `${window.location.pathname}?section_id=${sectionId}&variant=${currentVariant.id}&${searchParams}`;
  fetch(url).then(response => response.text()).then(responseText => {
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    contentToUpdate.forEach(function (content) {
      const html = parsedHTML.getElementById(content);
      const htmlInPageDom = document.getElementById(content);
      if (html && htmlInPageDom) {
        document.getElementById(content).innerHTML = html.innerHTML;
      }
    });
  });
};
Axial.productPage.updateProductPageUrl = function () {
  const currentProduct = Axial.productPage.getCurrentProduct();
  const currentVariant = Axial.productPage.getCurrentVariant();
  if (!currentProduct || !currentVariant || window.Axial.editor_mode) {
    return;
  }
  window.history.replaceState({}, '', `${currentProduct.url}?variant=${currentVariant.id}`);
};
Axial.productPage.getFirstVariantFromOptions = function (option, value) {
  var product = Axial.productPage.getCurrentProduct();
  if (option === 'option1') {
    var variant = product.variants.find(function (variant) {
      return Axial.handleize(variant[option]) === Axial.handleize(value);
    });
  }
  if (option === 'option2') {
    let option1Value = document.querySelector(`.variant-option-button[data-option-id="option1"].active`);
    if (option1Value) {
      option1Value = option1Value.dataset.value;
    } else {
      option1Value = document.querySelector(`.variant-option[data-option-label="option1"] select`).value;
    }
    var variant = product.variants.find(function (variant, index) {
      return Axial.handleize(variant[option]) === Axial.handleize(value) && Axial.handleize(variant["option1"]) === option1Value;
    });
  }
  if (option === 'option3') {
    let option1Value = document.querySelector(`.variant-option-button[data-option-id="option1"].active`);
    if (option1Value) {
      option1Value = option1Value.dataset.value;
    } else {
      option1Value = document.querySelector(`.variant-option[data-option-label="option1"] select`).value;
    }
    let option2Value = document.querySelector(`.variant-option-button[data-option-id="option2"].active`);
    if (option2Value) {
      option2Value = option2Value.dataset.value;
    } else {
      option2Value = document.querySelector(`.variant-option[data-option-label="option2"] select`).value;
    }
    var variant = product.variants.find(function (variant, index) {
      return Axial.handleize(variant[option]) === Axial.handleize(value) && Axial.handleize(variant["option1"]) === option1Value && Axial.handleize(variant["option2"]) === option2Value;
    });
  }
  return variant;
};
Axial.productPage.getVariantFromSpecificOptions = function (options) {
  var product = Axial.productPage.getCurrentProduct();
  var variantOption1 = false;
  var variantOption2 = false;
  var variantOption3 = false;
  var variant = product.variants.find(function (variant) {
    // Option 1
    var currentOption1 = false;
    if (variant.option1) {
      variantOption1 = Axial.handleize(variant.option1);
    }
    if (options['option1']) {
      currentOption1 = Axial.handleize(options['option1']);
    }

    // Option 2
    var currentOption2 = false;
    if (variant.option2) {
      variantOption2 = Axial.handleize(variant.option2);
    }
    if (options['option2']) {
      currentOption2 = Axial.handleize(options['option2']);
    }

    // Option 3
    var currentOption3 = false;
    if (variant.option3) {
      variantOption3 = Axial.handleize(variant.option3);
    }
    if (options['option3']) {
      currentOption3 = Axial.handleize(options['option3']);
    }
    return currentOption1 && variantOption1 === currentOption1 && variantOption2 === currentOption2 && variantOption3 === currentOption3;
  });
  return variant;
};
Axial.productPage.updateProductOptions = function () {
  const optionArray = ['option1', 'option2', 'option3'];
  optionArray.forEach(function (optionId) {
    const currentVariant = Axial.productPage.getCurrentVariant();
    if (currentVariant[optionId]) {
      window.currentProductOptions[optionId] = Axial.handleize(currentVariant[optionId]);
    }
  });
  optionArray.forEach(function (optionId) {
    if (window.currentProductOptions[optionId]) {
      let optionValue = Axial.handleize(window.currentProductOptions[optionId]);
      if (optionValue) {
        let $currentActiveButton = document.querySelector('.variant-option-button[data-option-id="' + optionId + '"].active');
        if ($currentActiveButton) {
          $currentActiveButton.classList.remove('active');
          let $newValue = document.querySelector('.variant-option-button[data-option-id="' + optionId + '"][data-value="' + optionValue + '"]');
          $newValue.classList.add('active');
        } else {
          $currentActiveButton = document.querySelector('.variant-option select[name="' + optionId + '"]');
          if ($currentActiveButton) {
            $currentActiveButton.value = optionValue;
          }
        }
      }
    }
  });
};
Axial.productPage.getCurrentProduct = function () {
  const product = window.currentProductData;
  if (!product) {
    return false;
  }
  return product;
};
Axial.productPage.setCurrentVariantById = function (variantId) {
  const product = window.currentProductData;
  if (!product) {
    return false;
  }
  var newVariant = product.variants.find(variant => parseInt(variant.id) === parseInt(variantId));
  if (!newVariant) {
    return false;
  }
  window.currentVariantData = newVariant;
  return newVariant;
};
Axial.productPage.getCurrentVariant = function () {
  const variant = window.currentVariantData;
  if (!variant) {
    return false;
  }
  return variant;
};
Axial.productPage.getCurrentProductImages = function () {
  const productMedia = window.currentProductMedia;
  if (!productMedia) {
    return false;
  }
  return productMedia;
};
Axial.productPage.getProductImage = function (mediaId) {
  const imagesData = Axial.productPage.getCurrentProductImages();
  if (!imagesData) {
    return false;
  }
  var newImage = imagesData.find(image => parseInt(image.id) === parseInt(mediaId));
  return newImage ? newImage : false;
};
Axial.productPage.getVariantFromMediaId = function (mediaId) {
  const variants = Axial.productPage.getCurrentProduct().variants;
  if (!variants) {
    return false;
  }
  var variant = variants.find(variant => parseInt(variant.featured_media.id) === parseInt(mediaId));
  return variant ? variant : false;
};
Axial.productPage.updateVariantSelector = function () {
  const currentVariant = Axial.productPage.getCurrentVariant();
  const variantSelector = document.querySelector('#productSelect');
  variantSelector.value = currentVariant.id;
};
Axial.productPage.updateMiniCartCount = function (amount) {
  const $cartAmount = document.querySelectorAll('.cart-item-amount');
  if ($cartAmount) {
    $cartAmount.forEach(function (cartItem) {
      cartItem.innerHTML = amount;
      if (cartItem.classList.contains('hidden')) {
        cartItem.classList.remove('hidden');
      }
    });
  }
};
Axial.productPage.setOptionAvailability = function (variants, option) {
  let arrayOfValues = [];
  variants.forEach(function (variant) {
    arrayOfValues.push(Axial.handleize(variant[option]));
  });
  let uniqueItems = [...new Set(arrayOfValues)];
  uniqueItems.forEach(function (item) {
    const variantHasInventory = variants.filter(variant => Axial.handleize(variant[option]) === item && variant.available === true);
    let currentItem = document.querySelector(`.variant-option-button[data-value="${item}"][data-option-id="${option}"]`);
    if (currentItem) {
      currentItem.classList.remove('unavailable');
      if (variantHasInventory.length > 0) {
        currentItem.classList.remove('no-inventory');
      } else {
        currentItem.classList.add('no-inventory');
      }
    } else {
      currentItem = document.querySelector(`.variant-option select option[value="${item}"]`);
      if (currentItem) {
        currentItem.disabled = false;
      }
    }
  });
};
Axial.productPage.updateVariantOptionStatus = function () {
  const variantButtons = document.querySelectorAll(`.variant-option-button[data-option-id="option2"],.variant-option-button[data-option-id="option3"]`);
  if (variantButtons) {
    variantButtons.forEach(function (button) {
      button.classList.add('unavailable');
    });
  }
  const variantSelectOptions = document.querySelectorAll(`.variant-option select[name="option2"] option, .variant-option select[name="option3"] option`);
  if (variantSelectOptions) {
    variantSelectOptions.forEach(function (option) {
      option.disabled = true;
    });
  }
  let selectedOption1 = window.currentProductOptions.option1;
  let selectedOption2 = window.currentProductOptions.option2;
  let productVariants = window.currentProductData.variants;
  const selectedVariants = productVariants.filter(variant => Axial.handleize(variant.option1) === selectedOption1);
  if (selectedOption2 && selectedVariants) {
    Axial.productPage.setOptionAvailability(selectedVariants, 'option2');
    const option3Variants = productVariants.filter(variant => Axial.handleize(variant.option1) === selectedOption1 && Axial.handleize(variant.option2) === selectedOption2);
    if (window.currentProductOptions.option3 && option3Variants) {
      Axial.productPage.setOptionAvailability(option3Variants, 'option3');
    }
  }
};
Axial.productPage.selectVariant = function (variantId) {
  var variant = Axial.productPage.setCurrentVariantById(variantId);
  if (!variant) {
    return false;
  }

  // Update variant selector without triggering a change event. This will avoid an infinite loop :)
  Axial.productPage.updateVariantSelector();

  // Update page url
  Axial.productPage.updateProductPageUrl();

  // Update variant price
  Axial.productPage.updateProductPagePrice();

  // Update variant sku
  Axial.productPage.updateProductPageSku();

  // Update variant image
  Axial.productPage.updateProductPageMedia();

  // Update add to cart button
  Axial.productPage.updateAddToCartButton();

  // Update using ajax
  Axial.productPage.updateUsingAjax();

  // Update options
  Axial.productPage.updateProductOptions();

  //Update Options status
  Axial.productPage.updateVariantOptionStatus();
};
Axial.productPage.updateQuantity = function (quantity) {
  const $quantityInput = document.querySelector('#Quantity');
  if (quantity < 0) {
    quantity = 0;
  }
  $quantityInput.value = quantity;
};
Axial.productPage.getStrings = function () {
  const strings = window.currentPageStrings;
  if (!strings) {
    return false;
  }
  return strings;
};
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}
productPageInit();
})();

/******/ })()
;